import Visibility from "@material-ui/icons/Visibility"
import React from "react"
import Table from "Components/Table/Table"
import Edit from "@material-ui/icons/Edit"
import { useBomTable } from "./hooks/table"
import { useFetchMaterials } from "./hooks/materials"
import Dialog from "./Dialog"
import { useTableStyles } from "./styles"
import EnhancerToolBar from "./EnhancerToolBar"

const Material = (props: {
    channelName?: string,
    columns: any,
    title: string,
}) => {
    const classes = useTableStyles()
    const { columns, title, channelName } = props
    // 数据获取相关
    const {
        data, query, loading, handleChangeItem,
        handleChangeQuery,
    } = useFetchMaterials(channelName)
    const {
        toggle, handleChangeData,
        handleChangeEditIndex, dialogProps,
        update,
    } = useBomTable(handleChangeItem)
    const isBom = title === "物料上传"
    return (
        <div className={classes.container}>
            {channelName && (
                <EnhancerToolBar
                    keyword={query.keyword || ""}
                    channelName={channelName}
                    onSearch={(searchQuery) => {
                        handleChangeQuery({ ...searchQuery, page: 1 })
                    }} />
            )}
            <Table
                components={{ Toolbar: () => null }}
                options={{
                    rowStyle: (data: any) => {
                        const isDraft = data.is_draft
                        const isPass =
                            new Date(data.ad_time).getTime() < new Date().setHours(0, 0, 0) - (24 * 3600 * 1000)
                        if (isPass && !isDraft) {
                            return {
                                backgroundColor: "#eee",
                            }
                        } else {
                            return {}
                        }
                    },
                    toolbarButtonAlignment: "right",
                    pageSize: 20,
                    pageSizeOptions: [20],
                    headerStyle: {
                        whiteSpace: "nowrap",
                    },
                    maxBodyHeight: "65vh",
                    minBodyHeight: "65vh",
                    emptyRowsWhenPaging: false,
                    actionsColumnIndex: 100,
                    search: false,
                }}
                columns={columns}
                title={title}
                data={data}
                loading={loading}
                totalCount={Number(query.totalCount)}
                page={query.page - 1}
                actions={[
                    (rowData: any) => {
                        const isDraft = rowData.is_draft
                        const isPass =
                            new Date(rowData.ad_time).getTime() < new Date().setHours(0, 0, 0) - (24 * 3600 * 1000)
                        // 过期或者没有修改权限时不能编辑，不包括备选列表的草稿内容
                        return {
                            icon: (isPass && !isDraft) || !update ? Visibility : Edit,
                            tooltip: isPass || !update ? "查看" : "编辑",
                            onClick: (event: any, rowData: any) => {
                                toggle(true)
                                const index = data.findIndex(({ id }) => id === rowData.id)
                                handleChangeData(rowData)
                                handleChangeEditIndex(index)
                            },
                        }
                    },
                ]}
                onChangePage={(page) => {
                    handleChangeQuery({ page: page + 1 })
                }}
            />
            <Dialog {...dialogProps} isBom={isBom} />
        </div>
    )
}

export default Material
